import { IUserResponse } from "../../../Orchestrator/Types/Interface/IUser";

export class MyAccountContext {
    public routeTo: string[] = []
    public userDetails?: IUserResponse;
    eventHandlers: { off: () => void }[] = [];

    constructor() {

    }
} 